var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8405 9.11711L15.2363 4.55867L22.8409 0L22.8421 9.11872L19.7236 11.0003L22.8571 9.12182L22.8571 20.7968L15.2271 25.4004V25.37L7.63003 29.9536V30L1.47048e-06 25.3964L0 13.7215L0.418219 13.9722L0.0038721 13.7222L0.00387246 13.7194L7.60278 18.2747V18.2654L15.2123 13.7038L15.2123 13.6818L15.2191 13.6859L22.8405 9.11711Z",
    fill: "#3C484D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00507347 4.60315L7.6351 9.17709V9.17847L7.60328 9.15939L0.00387304 13.715L0.00507347 4.60315Z",
    fill: "#3C484D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2eb71afc98ef0f41d220dadc59277eb6.svg";
export { ForwardRef as ReactComponent };